import "./ClientCheck.css"

import { Button, type UploadFile } from "antd"
import Dragger from "antd/es/upload/Dragger"
import React, { useRef, useState } from "react"
import ReactSignatureCanvas from "react-signature-canvas"

import draggerFunctions from "../../../helpers/draggerFunctions"
import { type ApplicationState } from "../../../store"
import DraggerInside from "../../DraggerInside"

type AfterFinishPayload = {
  clientPicture: ApplicationState["onefleetentrega"]["data"]["clientPicture"]
  clientSignatureDots: ApplicationState["onefleetentrega"]["data"]["clientSignatureDots"]
  clientSignatureImage: ApplicationState["onefleetentrega"]["data"]["clientSignatureImage"]
}

type OwnProps = {
  defaults?: ApplicationState["onefleetentrega"]
  afterFinish?: (payload: AfterFinishPayload) => void
}

const ClientCheck = (props: OwnProps): React.ReactElement => {
  const [fileList, setFileList] = useState<UploadFile[]>(props.defaults?.data.clientPicture ? [props.defaults?.data.clientPicture] : [])
  const [showError, setShowError] = useState<boolean>(false)
  const canvasRef = useRef<ReactSignatureCanvas>()

  React.useEffect(() => {
    window.dispatchEvent(new Event("resize"))

    if (props.defaults?.data.clientSignatureDots) {
      canvasRef.current?.fromData(props.defaults.data.clientSignatureDots)
    }
  }, [])

  const handleNextButtonClick = () => {
    if (props.afterFinish && canvasRef.current) {
      const signatureDots = canvasRef.current.toData()

      if (!fileList?.length || !signatureDots.length || fileList?.some(file => !file.name.match(/\.(png|jpeg|jpg)/g))) {
        setShowError(true)
        return
      }

      props.afterFinish({
        clientPicture: fileList[0],
        clientSignatureDots: canvasRef.current.toData(),
        clientSignatureImage: canvasRef.current.toDataURL()
      })
    }
  }

  return (
    <>
      <span className="title">ATENÇÃO!</span>
      <span className="subtitle">A assinatura e a foto devem ser <b>fornecidas pelo cliente</b> durante o processo de retirada do veículo, sendo capturadas no momento exato da retirada. <b>Solicitamos que não sejam enviadas fotografias de documentos ou imagens digitalizadas ou impressas.</b></span>

      <div style={{ textAlign: "left" }}>
        Foto do cliente
        <Dragger
          accept=".png,.jpg,.jpeg"
          onChange={(info) => { draggerFunctions.handleImageChange(info, 1, setFileList) }}
          fileList={fileList}
          customRequest={draggerFunctions.uploadFile}
          beforeUpload={draggerFunctions.beforeUploadFile}
        ><DraggerInside /></Dragger>
        {
          showError && !fileList.length && (<span className="error-text">Campo Obrigatório!</span>)
        }
      </div>

      <div style={{ textAlign: "left", display: "flex", flexDirection: "column" }}>
        Assinatura do cliente
        <div className="signatureContainer">
          <ReactSignatureCanvas
            canvasProps={{ height: 200 }}
            clearOnResize={true}
            // @ts-expect-error React signature canvas ref conflicts with ref, but it is the same thing
            ref={canvasRef}
          />
        </div>
        <Button onClick={() => canvasRef.current?.clear()}>Limpar Assinatura</Button>
        {
          showError && !canvasRef.current?.toData().length && (<span className="error-text">Campo Obrigatório!</span>)
        }
      </div>

      <Button type="primary" onClick={handleNextButtonClick}>Continuar</Button>

    </>
  )
}

export default ClientCheck
